var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    className: "pin_svg__nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5 5.5l10 10M9.5.5l6 6M2.146 7.146l8.997-5.003M8.854 13.854l5.003-8.997M4 12L.5 15.5"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiI+PGcgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgY2xhc3M9Im5jLWljb24td3JhcHBlciI+PGxpbmUgeDE9IjAuNSIgeTE9IjUuNSIgeDI9IjEwLjUiIHkyPSIxNS41Ij48L2xpbmU+IDxsaW5lIHgxPSI5LjUiIHkxPSIwLjUiIHgyPSIxNS41IiB5Mj0iNi41Ij48L2xpbmU+IDxsaW5lIHgxPSIyLjE0NiIgeTE9IjcuMTQ2IiB4Mj0iMTEuMTQzIiB5Mj0iMi4xNDMiPjwvbGluZT4gPGxpbmUgeDE9IjguODU0IiB5MT0iMTMuODU0IiB4Mj0iMTMuODU3IiB5Mj0iNC44NTciPjwvbGluZT4gPGxpbmUgeDE9IjQiIHkxPSIxMiIgeDI9IjAuNSIgeTI9IjE1LjUiPjwvbGluZT48L2c+PC9zdmc+";
export { SvgPin as ReactComponent };